import { render, staticRenderFns } from "./input-digits.vue?vue&type=template&id=bd344a3e"
import script from "./input-digits.vue?vue&type=script&lang=ts"
export * from "./input-digits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports